module.exports = __webpack_public_path__ + "img/Clients.923ac9cc.svg";